import { createFileRoute } from "@tanstack/react-router";
import { AccessProfileDetailFeature } from "@/features/access-profile-detail";

export const Route = createFileRoute("/access-profiles/$profileId/")({
  component: AccessProfileDetailPage,
  staticData: { authorize: true },
});

function AccessProfileDetailPage() {
  const params = Route.useParams();
  const profileId = Number(params.profileId);

  return <AccessProfileDetailFeature profileId={profileId} />;
}
